<template>
  <div class="eid-preview-wrap">
    <a-spin :spinning="spinning">
      <pageTitle pageTitle="没有找到我的设备提示" />
      <div class="page-main">
        <div class="video-title">
          <p class="title mt25" style="display: block">实时预览</p>
          <div class="eid-preview">
            <div class="preview">
              <div class="preview-header" />
              <div v-html="content" class="content-html" />
            </div>
            <div class="eid">
              <edit-components
                :uploadImg="uploadImg"
                :upload-path="uploadPath"
                :content="content"
                :html-change="htmlChange"
                v-if="show"
              />
              <a-button @click="save" type="primary" class="saveBtn" 
              :disabled="!isSave">保存</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import editComponents from "@/components/EditComponents";
import { client, multipartUpload } from "@/utils/Oss";

import { tips } from "@/utils/util";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

export default {
  components: {
    editComponents,
    pageTitle,
  },
  // props: {
  //   detailsUrl: undefined,
  //   saveUrl: undefined
  // },
  data() {
    return {
      isSave:false,//是否可以保存
      show: false,
      content: "",
      action: "",
      imageUrl: "",
      loading: false,
      imgSrc1: "",
      imgSrc2: "",
      id: 0,
      saveUrl: "bluetoothlight/web/system/content", //保存链接
      detailsUrl: "bluetoothlight/web/system/content?contentType=DEVICE_NOT_FOUND_TIPS", //查询链接
      spinning: false,
      videoCover: undefined, // 封面图片
      OssVideoCover: undefined, // 封面图片

      upLoading: false,
      files: [],
      fileName: undefined, // 文件的名字

      tutorialType: undefined,
      backURl: undefined,
      conCopy:null,
      uploadPath: "bluetooth_light"
    };
  },
  created() {
    // when adding,  not id
    // this.id = this.$route.query.commodityId;
    // detailsUrlFormValues  JSON.P
    this.getDetail(this.detailsUrl);
  },

  methods: {
    uploadImg: async function (file, callback, contextPath) {
      const res = await multipartUpload(file?.name, file, null, contextPath || "bluetooth_light");
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        this.upLoading = false;
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      callback && callback?.(res?.url);
    },
    /**
     *  获取详情
     *  @param {String} url 请求路径
     *  @param {Object} data 请求参数
     *  分别处理 图文 和 视频
     *  视频 editType === video
     * */
    getDetail: async function (url) {
      this.spinning = true;
      const res = await this.$get(this.detailsUrl);

      const resultData = res?.resultData;

      if (!resultData) return false;

      const { content } = resultData;
      this.show = true;
      this.content = content;
      this.conCopy = content;
      this.spinning = false;
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    /**
     *  文件上传处理 返回结果时 false, 结束upload的事件
     *  @param {File} file
     *  fileName 获取文件的 name或者id
     *  client 上传到oss 返回  {url,name}
     * */

    // UploadClient: async function (file) {
    //   this.fileName = file?.name || file?.uid;
    //   this.upLoading = true;
    //   const res = await client(this.fileName, file);
    //   this.files = [{ ...res, uid: file?.uid }];
    //   this.tutorialVideoUrl = res?.url;
    //   this.upLoading = false;
    //   if (this.editType === "video") {
    //     this.getVideoInfo();
    //   }
    // },

    // beforeUpload(file) {
    //   // console.log(file, 'beforeUpload');

    //   // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    //   // if (!isJpgOrPng) {
    //   //   this.$message.error("You can only upload JPG file!");
    //   // }
    //   // const isLt2M = file.size / 1024 / 1024 < 2;
    //   // if (!isLt2M) {
    //   //   this.$message.error("Image must smaller than 2MB!");
    //   // }
    //   // return isJpgOrPng && isLt2M;

    //   this.UploadClient(file);
    //   return false;
    // },
    remove() {
      this.files = [];
      this.tutorialVideoUrl = undefined;
      this.videoCover = undefined;
      this.OssVideoCover = undefined;
    },
    save: async function () {
      if(this.content?.replace(/<[^>]*>|<\/[^>]*>/gm, "") == ''){
        return this.$message.warning('内容不可为空');
      }
      // 保存事件要抛出
      if (this.spinning) return false;
      this.spinning = true;

      let payload = { content: this.content, contentType: "DEVICE_NOT_FOUND_TIPS" };
      const res = await this.$post(this.saveUrl, payload);
      const resultStatus = res?.resultStatus;
      this.spinning = false;
      if (resultStatus) {
        tips(this, true);
      }
    },
    htmlChange(html) {
      this.content = html;
      if(html != this.conCopy){
        this.isSave = true;
      }
    },
  },
};
</script>


<style lang="less">
.eid-preview-wrap {
  width: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  //display: flex;
  background: #fff;
  padding: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  //overflow: auto;
  height: 100%;

  .title {
    display: inline-block;
    font-size: 18px;
    padding: 10px 0;
  }

  .bb1 {
    border-bottom: 1px solid #ccc;
  }

  .mt25 {
    margin-top: 25px !important;
  }

  .eid-preview {
    min-height: calc(100% - 164px);

    .preview {
      width: 375px;
      min-height: calc(100% - 164px);
      border: 1px solid #ccc;
    }

    .preview-header {
      height: 88px;
      background-image: url("../../../assets/img/phone_header.png");
      background-repeat: no-repeat;
    }

    .content-html {
      word-wrap: break-word;
      word-break: break-all;
      font-size: 14px;
      font-weight: 500;

      line-height: 28px;
      color: #333;
      width: 100%;
      padding: 0 20px 10px 20px;
      text-align: left;
      //height: calc(100% - 50px);
      //div {
      //  //width: 100%;
      //  overflow-y: scroll;
      //
      //}
      iframe {
        width: 100%;
      }
    }
  }

  //.eid {
  //  min-height: 400px;
  //}
  .video-title {
    display: flex;
    margin-top: 15px;
    font-size: 18px;

    .title {
      flex: 0 0 150px;
    }
  }
}

.eid-preview {
  display: flex;
  justify-content: space-between;

  .preview,
  .eid {
    width: 55%;
  }

  .w-e-text {
    padding-top: 10px;
  }

  .eid {
    .saveBtn {
      display: block;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
}

.question_detail_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 2px solid #eee;
    margin-left: 5px;
  }

  &_help {
    background: none;
    //border-top: none;
    //border-left: none;
    //border-right: none;
    border: none;
    //width: 500px;
    outline: none;
  }

  .answer {
    display: flex;
    width: 80%;
    margin: 0 auto;
    flex-direction: row;
    //justify-content: space-between;
    justify-content: space-evenly;

    .content {
      display: flex;
      flex-direction: column;
      text-align: center;
      width: 40%;
      padding: 10px;
      box-sizing: border-box;

      &_msg {
        width: 100%;
        min-height: 300px;
        border: 2px solid #eee;
        padding: 10px;

        &_header {
          padding: 10px;
          width: 100%;
          font-size: 10px;
        }

        &_pic {
          //width: 80%;

          height: 200px;
          background-color: #d9d9d9;
          margin: 10px;
        }
      }

      &_edit {
        width: 100%;
        height: 300px;
        margin-top: 10px;
        padding: 10px;
        box-sizing: border-box;
        border: 2px solid #eee;
        text-align: left;
        // .avatar-uploader{
        //     width: 200px;
        // }
      }
    }
  }
}
</style>
